import React from 'react';

/**
 * Tab control component for switching between tabs
 * @param {Object} props Component props
 * @param {string} props.label Label text for the tab
 * @param {boolean} props.active Whether the tab is currently active
 * @param {Function} props.onClick Handler for tab click event
 * @returns {React.ReactElement} TabControl component
 */
const TabControl = ({ label, active, onClick }) => (
  <button 
    className={`tab-control ${active ? 'active' : ''}`} 
    onClick={onClick}
  >
    {label}
  </button>
);

export default TabControl; 